import { Button } from "@chakra-ui/react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { Raster } from "@nens/threedi/openapi-client";

import { getMinMaxForLayers, getMinMaxUrls, setMinMax } from "../state/layerRasterSourcesMenu";
import { getMapBounds } from "../state/map";
import { getMinMax } from "../utils/getMinMax";

import LayerMenuModelRasterLayer from "./LayerMenuModelRasterLayer";
import LayerSubMenu from "./LayerSubMenu";

interface Props {
  demRaster: Raster;
}

const LayerMenuModelRastersSubmenu: React.FC<Props> = ({ demRaster }) => {
  const dispatch = useDispatch();
  const minMaxUrls = useSelector(getMinMaxUrls);
  const bounds = useSelector(getMapBounds);
  const demMinMax = useSelector(getMinMaxForLayers).find((data) => data.layer === "dem_file");
  const demMinMaxUrl = minMaxUrls.find((data) => data.layer === "dem_file");

  const isDefaultColorScale =
    demMinMax && demMinMax.min === demMinMax.defaultMin && demMinMax.max === demMinMax.defaultMax;
  return (
    <LayerSubMenu>
      <LayerSubMenu.Header>
        <FormattedMessage id="layerMenu.modelrastersHeader" defaultMessage="Model Rasters" />
      </LayerSubMenu.Header>

      <LayerSubMenu.ItemList>
        <LayerMenuModelRasterLayer raster={demRaster} />

        <Button
          variant="secondary"
          w="fit-content"
          ml="auto"
          mr={4}
          onClick={async () => {
            if (!demMinMax || !demMinMaxUrl || !bounds) return;
            const minMax = await getMinMax(demMinMaxUrl.minmax.url, bounds);
            if (!minMax) return;
            dispatch(
              setMinMax({
                ...demMinMax,
                min: minMax.min,
                max: minMax.max,
              })
            );
          }}
          isDisabled={!demMinMax || !demMinMaxUrl}
        >
          Rescale color range
        </Button>
        {demMinMax && !isDefaultColorScale && (
          <Button
            variant="secondary"
            w="fit-content"
            ml="auto"
            mr={4}
            onClick={() => {
              dispatch(
                setMinMax({
                  ...demMinMax,
                  min: demMinMax.defaultMin,
                  max: demMinMax.defaultMax,
                })
              );
            }}
          >
            Reset color range
          </Button>
        )}
      </LayerSubMenu.ItemList>
    </LayerSubMenu>
  );
};

export default LayerMenuModelRastersSubmenu;
